import { CanDeactivateFn } from '@angular/router';

import { EntityDetailsComponent } from './components';

export const entityDeactivateGuard: CanDeactivateFn<EntityDetailsComponent> = (component) => {
    return component.canDeactivate();
};
